import { PageLayout } from '@/components/UI/Layouts/Admin/PageLayout';
import { useNavigate } from 'react-router-dom';
import { Form, FormData } from './Form';
import toast from 'react-hot-toast';
import { ROUTES } from '@/config/routes';
import { useCreateOne } from '@/queries/admin';

export const Create = () => {
  const navigate = useNavigate();
  const { mutateAsync: createApplication } = useCreateOne('applications');

  const onSubmit = async (data: FormData) => {
    try {
      await createApplication({ data });
      toast.success('Группа успешно обновлена');
      navigate(ROUTES.ADMIN.APPLICATIONS);
    } catch (error) {
      console.error('Error updating:', error);
      toast.error('Произошла ошибка при обновлении группы');
    }
  };

  return (
    <PageLayout
      breadcrumbs={[
        {
          label: 'Приложения',
          href: ROUTES.ADMIN.APPLICATIONS,
        },
        {
          label: 'Создание',
          href: '',
        },
      ]}
    >
      <Form onSubmit={onSubmit} />
    </PageLayout>
  );
};
